// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__95gRI","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1mcT2"};